<template>
  <div v-if="!verified" class="age-verify-overlay">
    <div class="age-verify-modal">
      <img src="@/assets/images/logo.webp" alt="Logo" class="logo mb-4" width="120" height="170" decoding="async" />
      <h2>Verificación de Edad</h2>
      <p class="mb-4">Debes ser mayor de 18 años para acceder a este sitio.</p>
      <div class="d-flex gap-3">
        <button @click="verify(true)" type="button" class="btn btn-primary px-3 py-2">
          <i class="fas fa-check me-2" aria-hidden="true"></i>
          Soy mayor de 18
        </button>
        <button @click="verify(false)" type="button" class="btn btn-outline-light px-3 py-2">
          <i class="fas fa-times me-2" aria-hidden="true"></i>
          Soy menor
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

// Start as verified so the hero renders first (avoids NO_LCP for Lighthouse and new users)
const verified = ref(true);

const verify = (isAdult) => {
  if (isAdult) {
    localStorage.setItem('ageVerified', 'true');
    verified.value = true;
  } else {
    window.location.href = 'https://www.google.com';
  }
};

onMounted(() => {
  if (localStorage.getItem('ageVerified') === 'true') {
    // Returning user: already verified, keep hidden
    verified.value = true;
  } else {
    // New user: let the browser paint one frame so the hero is the LCP candidate,
    // then show the age gate overlay (double-rAF is the standard pattern for this)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        verified.value = false;
      });
    });
  }
});
</script>

<style scoped>
.age-verify-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.age-verify-modal {
  background: var(--black-color-3);
  padding: 2rem;
  border-radius: 1rem;
  text-align: center;
  max-width: 90%;
  width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.logo {
  width: 120px;
  height: auto;
  margin: 0 auto;
}

h2 {
  color: var(--white-color);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

p {
  color: var(--white-color-2);
  opacity: 0.8;
}

.btn {
  flex: 1;
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

@media (max-width: 576px) {
  .age-verify-modal {
    padding: 1.5rem;
  }
  
  .btn {
    padding: 0.5rem !important;
    font-size: 0.9rem;
  }
}
</style>
